import { PostgrestClient } from '@supabase/postgrest-js';
import { RealtimeClient } from '@supabase/realtime-js';
import type { Database } from './types';

/** Public SELECT + anonymous Realtime only; no auth session or storage SDK is loaded. */
export function createPublicClient(supabaseUrl: string, anonKey: string, fetcher: typeof fetch = globalThis.fetch) {
  const base = new URL(supabaseUrl.endsWith('/') ? supabaseUrl : `${supabaseUrl}/`);
  if (!['https:', 'http:'].includes(base.protocol) || !anonKey) throw new Error('Invalid public Supabase configuration');
  const rest = new PostgrestClient<Database>(new URL('rest/v1', base).href, {
    schema: 'public', headers: { apikey: anonKey, Authorization: `Bearer ${anonKey}` }, fetch: fetcher, timeout: 10000,
  });
  const realtimeUrl = new URL('realtime/v1', base);
  realtimeUrl.protocol = realtimeUrl.protocol.replace('http', 'ws');
  const realtime = new RealtimeClient(realtimeUrl.href, {
    params: { apikey: anonKey }, accessToken: async () => anonKey, fetch: fetcher,
  });
  return {
    from: rest.from.bind(rest),
    channel: realtime.channel.bind(realtime),
    removeChannel: realtime.removeChannel.bind(realtime),
  };
}

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
function configuredPublicClient(): ReturnType<typeof createPublicClient> | null {
  if (!supabaseUrl || !supabaseAnonKey) return null;
  try { return createPublicClient(supabaseUrl, supabaseAnonKey); }
  catch { return null; }
}
export const supabase = configuredPublicClient();
